// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iiL8","right":"styles_right__1leKg"};